import { useState, useEffect } from "react";
import { Box, Tabs, Tab } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";

// Components
import ContactsTab from "../contacts/ContactsTab";
import GroupsTab from "../contacts/GroupsTab";
import Header from "./Header";

// Theme
import { tokens } from "../../theme";

// Context
import { useLocation } from "react-router-dom";
import { trackEvent } from "../utils/Utils";

export default function Contacts() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [value, setValue] = useState(0);
  const location = useLocation();
  const { t } = useTranslation();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get("tab");

    trackEvent("messages-tab_clicked", { tab });

    if (tab === "groups") {
      setValue(1);
    } else {
      setValue(0);
    }
  }, [location.search]);

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: "1600px", mx: "auto" }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Header
          title={t("contacts.headerTitle")}
          subtitle={t("contacts.headerSubtitle")}
        />
      </Box>

      <Box sx={{ mb: 4 }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: "48px",
            bgcolor: theme.palette.mode === 'dark' ? "rgba(0,0,0,0.2)" : "rgba(0,0,0,0.03)",
            borderRadius: "12px",
            p: 0.5,
            display: "flex",
            maxWidth: "100%",
            "& .MuiTabs-indicator": {
              display: "none",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "600",
              fontSize: "0.95rem",
              minHeight: "40px",
              borderRadius: "8px",
              color: theme.palette.mode === 'dark' ? "#a1a4ab" : "#727681",
              transition: "all 0.3s ease",
              px: 4,
              "&.Mui-selected": {
                color: theme.palette.mode === 'dark' ? "#fff" : "#141b2d",
                bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.1)" : "#fff",
                boxShadow: theme.palette.mode === 'dark' ? "none" : "0 2px 8px rgba(0,0,0,0.05)",
              },
              "&:hover:not(.Mui-selected)": {
                color: theme.palette.mode === 'dark' ? "#fff" : "#141b2d",
                bgcolor: theme.palette.mode === 'dark' ? "rgba(255,255,255,0.05)" : "rgba(255,255,255,0.5)",
              },
            },
          }}
        >
          <Tab disableRipple label={t("contacts.tabContacts")} />
          <Tab disableRipple label={t("contacts.tabGroups")} />
        </Tabs>
      </Box>

      {/* Content wrapper with glassmorphism */}
      <Box
        sx={{
          bgcolor: theme.palette.mode === 'dark' ? "rgba(20, 27, 45, 0.7)" : "#ffffff",
          backdropFilter: "blur(10px)",
          borderRadius: "16px",
          boxShadow: theme.palette.mode === 'dark' ? "0 8px 32px 0 rgba(0, 0, 0, 0.3)" : "0 8px 32px 0 rgba(31, 38, 135, 0.05)",
          border: theme.palette.mode === 'dark' ? "1px solid rgba(255, 255, 255, 0.05)" : "1px solid rgba(0, 0, 0, 0.05)",
          p: { xs: 2, md: 3 },
          minHeight: "500px"
        }}
      >
        {value === 0 && <ContactsTab />}
        {value === 1 && <GroupsTab />}
      </Box>
    </Box>
  );
}
